import { render, staticRenderFns } from "./DeptIssueReport.vue?vue&type=template&id=65dac876&scoped=true"
import script from "./DeptIssueReport.vue?vue&type=script&lang=js"
export * from "./DeptIssueReport.vue?vue&type=script&lang=js"
import style0 from "./DeptIssueReport.vue?vue&type=style&index=0&id=65dac876&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dac876",
  null
  
)

export default component.exports